var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArticlePreviewStar = function SvgArticlePreviewStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.512 31.202c-.42-2.059-.84-4.09-1.246-6.19-.285-1.363-.502-2.808-.813-4.212a3.661 3.661 0 0 0-.986-1.88 3.626 3.626 0 0 0-1.86-1.01 75.002 75.002 0 0 1-8.862-2.726c-.176 0-.338-.177-.745-.382 2.602-.504 4.919-.981 7.25-1.363a7.444 7.444 0 0 0 4.2-1.827 3.984 3.984 0 0 0 1.003-1.554c.596-2.1 1.11-4.226 1.599-6.353.257-1.104.406-2.235.61-3.435.142.206.264.425.365.654a27.796 27.796 0 0 1 1.884 5.999c.032.765.259 1.51.657 2.164a4.497 4.497 0 0 0 1.619 1.57c1.057 1.732 2.927 1.787 4.593 2.237 1.667.45 3.578.858 5.42 1.295.305.068.583.224.8.45-1.585.272-3.184.49-4.756.818-1.572.327-3.333.817-4.986 1.28a3.92 3.92 0 0 0-1.83 1.446c-1.694 1.99-1.748 4.499-2.317 6.816-.42 1.759-.705 3.545-1.057 5.317 0 .327-.176.64-.27.954l-.272-.068Z",
    fill: "#EDD4A6"
  })));
};

export default SvgArticlePreviewStar;